module.exports = __webpack_public_path__ + "static/media/reward1.77c08985.png";